export enum AaaShippingType {
  retailAndDigital = "retailAndDigital",
  digitalOnlyF2P = "digitalOnlyF2P",
  digitalOnly = "digitalOnly",
}

export enum CrossVersionPlatforms {
  WindowsStore = "WindowsStore",
  PS4 = "PS4",
  PS5 = "PS5",
  Switch = "Switch",
  Epic = "Epic",
  Steam = "Steam",
  Luna = "Luna",
  Android = "Android",
  iOs = "iOS",
  Xbox = "Xbox",
  Other = "Other",
}
